export const API_BY_COUNTRY = {
    // developer: "http://mapi.dev.miira.ca/v1",
    // developer: "http://192.168.16.115:1717/v1",
    developer: "http://localhost:1717/v1/online",
    Canada: "https://api.miirapos.com/v1/online",
    India: "https://api.in.miirapos.com/v1/online",
};